import { useSelector } from 'react-redux';
import LoginLayout from '../../layouts/loginLayout/LoginLayout';

function AuthComponent(props) {
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);

  return (
    <>
      {isLoggedIn || localStorage.getItem('token')?.length ? (
        props.children
      ) : (
        <LoginLayout />
      )}
    </>
  );
}

export default AuthComponent;
